export function hasSummary(fields: any): fields is { summary: string } {
    return fields && 'summary' in fields;
}
export function hasTitle(fields: any): fields is { title: string } {
    return fields && 'title' in fields;
}

export function hasAuthors(fields: any): fields is { authors: { name: string }[] } {
    return fields && 'authors' in fields;
}
